import React from "react";
import "./ConsultationRatings.scss";

import StarRating from "../../../atoms/StarRating/StarRating";
import { ConsultationRatingSummary } from "../../../types/consultation";

interface ConsultationRatingsProps {
  summary: ConsultationRatingSummary;
}

const ConsultationRatings: React.FC<ConsultationRatingsProps> = ({
  summary,
}) => {
  const average = summary.average ?? 0;

  return (
    <div className="cs-ratings">
      <div className="csr-overall">
        <div className="csr-bigwrap">
          <span className="csr-big">{average.toFixed(1)}</span>
          <span className="csr-of">/ {summary.maxValue || 5}</span>
        </div>
        <StarRating value={average} size="lg" />
        {!!summary.caption && <div className="csr-sub">{summary.caption}</div>}
      </div>

      {!!summary.byCoach?.length && (
        <div className="csr-list">
          <div className="csr-list-h">
            {summary.byCoachTitle || "Rating by coach"}
          </div>
          {summary.byCoach.map((coach) => {
            const coachAverage = coach.average ?? 0;
            const count = coach.ratingCount ?? 0;

            return (
              <div
                key={coach.healthCoachId}
                className={`csr-row ${coach.isCurrentUser ? "me" : ""}`}
                style={
                  {
                    ["--c" as any]: coach.dotColor || "var(--ink-2)",
                  } as React.CSSProperties
                }
              >
                <span className="csr-dot" />
                <span className="csr-coach">
                  {coach.name}
                  {coach.isCurrentUser && <span className="csr-you">You</span>}
                </span>
                <StarRating value={coachAverage} />
                <span className="csr-avg">{coachAverage.toFixed(1)}</span>
                <span className="csr-n">
                  {count} rating{count === 1 ? "" : "s"}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ConsultationRatings;
